import { AccessTokenChangedError } from '~/Api/Authentication';
import { ApiClientErrorResponse } from '~/ApiClient';
import { redirectWithBacklink } from '~/Backlink';
import config from '~/config';
import { flashErrorMessage } from '~/FlashMessage/actions';
import { ThunkAction } from '~/Store';

export type AppError = unknown | Error | globalThis.Error | ApiClientErrorResponse;
export type Logger = (error: AppError) => any;
let currentLogger: Logger = console.error; // tslint:disable-line: no-console

export function installErrorLogger(logger: Logger): void {
	currentLogger = logger;
}

export function handleError(error: AppError): ThunkAction<void, any> {
	return (dispatch) => {
		if (error instanceof AccessTokenChangedError) {
			return;
		}
		if (error instanceof ApiClientErrorResponse && dispatch(handleApiError(error))) {
			return;
		}

		currentLogger(error);
		dispatch(flashErrorMessage());
	};
}

function handleApiError(errorResponse: ApiClientErrorResponse): ThunkAction<boolean, any> {
	return (dispatch) => {
		const accountExpired = errorResponse.handle('authentication-expired-account');

		if (
			accountExpired ||
			errorResponse.handle('missing-access-token') ||
			errorResponse.handle('authentication-inactive-security-token') ||
			errorResponse.handle('authentication-unknown-security-token')
		) {
			dispatch(redirectWithBacklink({ pathname: '/login', hash: '', search: '' }));
		}
		if (accountExpired) {
			dispatch(flashErrorMessage(`Your user account has expired, please contact ${config.support.email}`));
		}
		if (errorResponse.handle('network-error')) {
			dispatch(flashErrorMessage('Network connection error, please try again or refresh the page.'));
		}
		if (errorResponse.statusCode === 403 && errorResponse.handle(null)) {
			dispatch(
				flashErrorMessage(`Access denied. Please contact ${config.support.email} if you need more information.`)
			);
		}
		return errorResponse.isHandled();
	};
}
